














import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class NavBarMenu extends Vue {
  @Prop({ default: false }) private isHoverable?: boolean;

  isDropdownActive = false;

  // Getters
  get toggleDropdownIcon() {
    return this.isDropdownActive ? "chevron-up" : "chevron-down";
  }

  // Methods
  toggle() {
    if (!this.isHoverable) {
      this.isDropdownActive = !this.isDropdownActive;
    }
  }

  forceClose(e: any) {
    if (!this.$el.contains(e.target)) {
      this.isDropdownActive = false;
    }
  }

  // Life-cycle hooks
  created() {
    window.addEventListener("click", this.forceClose);
  }

  beforeDestroy() {
    window.removeEventListener("click", this.forceClose);
  }
}
